import { DEFAULT_LOCALE } from "./number-format.util"

// Mirrors LocaleSupport::LANGUAGE_DEFAULT_LOCALES (app/concerns/locale_support.rb),
// the source of truth; test/concerns/locale_support_test.rb fails when the two
// tables differ. Bare English is day-first (en-GB), like the server's `en`.
const EXPLICIT = {
  sk: "sk-SK",
  en: "en-GB",
  cs: "cs-CZ",
  de: "de-DE",
  fr: "fr-FR",
  ro: "ro-RO",
  uk: "uk-UA" // Ukrainian: the country is UA; the fallback below would build uk-UK
}

export function userLocaleToBcp47(userLocale) {
  if (!userLocale) return DEFAULT_LOCALE

  const locale = userLocale.toLowerCase()
  if (EXPLICIT[locale]) return EXPLICIT[locale]
  if (userLocale.includes("-")) return userLocale
  return `${locale}-${userLocale.toUpperCase()}`
}
